import { useState, useEffect } from "react";
import useLocalStorageState from "use-local-storage-state";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Trash2, Pencil } from "lucide-react";
import { Button, Table } from "react-bootstrap";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm, Controller } from "react-hook-form";
import { RxCrossCircled } from "react-icons/rx";
import { toast } from "sonner";
import Select from "react-select"
import {
  GetRequest,
  PostRequest,
  PutRequest,
} from "../../Utils/hooks/ApiHandler";

// Schema definitions
const whatsappSchema = z.object({
  campaingingName: z.string().min(1, "Campainging name is required"),
  templateId: z.string().min(1, "Template ID is required"),
  templateContent: z.string().min(1, "Template content is required"),
});

// Mock data

export function WhatsappModal({
  currentTab,
  filterQueryValue,
  filterQueryValues,
}) {
  const navigate = useNavigate();
  const [customer, setCustomer] = useLocalStorageState("customer", {
    token: {},
  });
  const customerId = customer?.customer_details?.customer_id;
  const loginUserId = customer?.customer_details?.id;
  const token = customer?.token?.authorization;
  const rf = customer?.token?.authentication;
  const headers = {
    authentication: rf,
    Authorization: token,
  };

  const extras = { customer, setCustomer, rf, navigate };

  // Initialize activeTab from localStorage or default to "WhatsApp"
  const [activeTab, setActiveTab] = useState(() => {
    if (typeof window !== "undefined") {
      return localStorage.getItem("notificationActiveTab") || "WhatsApp";
    }
    return "WhatsApp";
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isWhatsAppModalOpen, setIsWhatsAppModalOpen] = useState(false);
   const [templateModuleOption, setTemplateModuleOption] = useState([])
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentTemplateId, setCurrentTemplateId] = useState(null);
  const [whatsappTableData, setWhatsappTableData] = useState([]);
  const [whatsappTemplateData, setWhatsappTemplateData] = useState(null);
  const [dynamicFields, setDynamicFields] = useState([]);




  

  // Create dynamic schema for WhatsApp form based on dynamic fields
  const createWhatsAppSchema = () => {
    const dynamicFieldValidations = {};

    dynamicFields.forEach((field) => {
      if (field.type === "image") {
        dynamicFieldValidations[field.name] = z
          .instanceof(FileList)
          .refine((files) => files?.length > 0, "Image is required");
      } else if (field.type === "url") {
        dynamicFieldValidations[field.name] = z.string().min(1, `${field.label} is required`)
          .url("Please enter a valid URL")
      } else {
        dynamicFieldValidations[field.name] = z
          .string()
          .min(1, `${field.label} is required`);
      }
    });

    return whatsappSchema.extend(dynamicFieldValidations);
  };

  // Form hooks
  const whatsappForm = useForm({
    resolver: zodResolver(createWhatsAppSchema()),
  });

  // Function to reset all form states
  const resetFormStates = () => {
    setIsEditMode(false);
    setWhatsappTemplateData(null);

    setDynamicFields([]);

    // Reset all forms
    whatsappForm.reset();
  };

  // Load templates based on active tab

  useEffect(() => {
        ; (async () => {
            try {
                const res = await GetRequest(
                    `common/fetchAllMsg91Template_moduleName/contact/${customer?.customer_details?.customer_id}`,
                    { headers },
                    extras,
                )
                if (res.status === "fail") {
                    return
                }
                const options = res.data.map((item) => ({
                    value: item.id,
                    label: item.template_name,
                }))
                setTemplateModuleOption(options)
            } catch (error) {
                toast.error("Error fetching Template Module Name")
                return
            }
        })()
    }, [])






  const templateId = whatsappForm.getValues("templateId");
    useEffect(() => {
        if (templateId !== null) {
        whatsappForm.setValue('templateContent', '')
            setDynamicFields([])
        }
    }, [templateId])





  const onWhatsAPPFetch = async () => {
   

    
 
    if (!templateId) {
      toast.error("Please enter a template ID first");
      return;
    }
const template = templateModuleOption.find((temp) => templateId === temp.value)
    setIsLoading(true);
    try {
      const res = await GetRequest(
        `/integration/fetchWhatsappTemplateContent/${template &&template.label}/${customerId}`,
        { headers },
        extras
      );
      if (res.status === "success") {
        const templateData = JSON.parse(res.data);

        setWhatsappTemplateData(templateData.data);

        // Find the BODY content
        const bodyContent = templateData.data[0].languages[0].code.find(
          (item) => item.type === "BODY"
        );
        if (bodyContent) {
          whatsappForm.setValue("templateContent", bodyContent.text || "");
        }

        // Extract variables and their types
        const variables = templateData.data[0].languages[0].variables || [];
        const variableTypes =
          templateData.data[0].languages[0].variable_type || {};

        // Create dynamic fields based on variables

        let count = 0;
        const fields = variables.map((variable) => {
          const varType = variableTypes[variable]?.type;
          let fieldType = "text";

          let label = variable;

          if (variable.startsWith("header_")) {
            count++;
            fieldType = varType;
            label = "Header";
          } else if (variable.startsWith("button_")) {
            count++;
            fieldType = "url";
            label = "Button URL";
          } else if (variable.startsWith("body_")) {
            count++;
            label = `Body Text ${variable.split("_")[1]}`;
          }

          return {
            name: variable,
            type: fieldType,
            label: label,
            required: true,
          };
        });

        setDynamicFields(fields);

        toast.success("Template fetched successfully");
      } else {
        toast.error(res.message || "Failed to fetch template");
      }
    } catch (error) {
      console.error("Error fetching WhatsApp template:", error);
      toast.error("Failed to fetch template");
    } finally {
      setIsLoading(false);
    }
  };

  // Handle status toggle

  // Form submission handler
  const onSubmit = async (data) => {
    setIsLoading(true);
    try {
      // Log all form data to console

      const variables = [];
      const variableValues = [];
      const variableTypes = [];
      let bodyCount = 0;
      let header_text = null;
      let header_image = null;

      dynamicFields.forEach((field) => {
         variables.push(field.name);
         variableTypes.push(field.type);

        if (field.name.startsWith("body_")) {
          bodyCount++;
        }

        // Handle file inputs differently
        if (field.type === "image" && field.name === "header_1") {
          header_image = data.header_1?.[0] || null;
        } else if (field.type === "text" && field.name === "header_1") {
        header_text = data.header_1 || null;
    }  else if (field.type === "url" && field.name === "button_1") {
          header_text = data.button_1 || null;
        } else {
          // Skip if type is "url" and name is "button_1"
          if (field.type === "url" && field.name === "button_1") {
            return;
          }
          variableValues.push(data[field.name] || "");
        }
      });
      const payload = {
        filter_query: (filterQueryValue.length > 0
          ? filterQueryValue
          : filterQueryValues
        ).map((f) => ({
          label_name: f.label_name,
          label_query: f.label_query,
          label_value: f.label_value,
        })),
        customer_id: customerId,
        campaign_name: data.campaingingName,
        module_name: currentTab,
        
        template_name: whatsappTemplateData?.[0]?.name || "",
        template_namespace: whatsappTemplateData?.[0]?.namespace || "",
        template_language:
          whatsappTemplateData?.[0]?.languages?.[0]?.language || "en",
        template_template_id:
          whatsappTemplateData?.[0]?.languages?.[0]?.id || "",
        template_variable_count: variables.length.toString(),
        template_variable_type: variables,
        template_variable_typeOFtype: variableTypes,
        template_body_count: bodyCount.toString(),
        template_content: data.templateContent,
        variables_value: variableValues,
        user_login_id: loginUserId,

        variables_value_url: data?.button_1 || null,
        header_image: header_image || null,
         header_text: header_text || null,
      };
      const res = await PostRequest(
        `/Campaiging/sendWhatsappMsg`,
        payload,
        true,
        { headers },
        extras
      );
      if (res.status === "success") {
        toast.success(
          `WhatsApp template ${isEditMode ? "updated" : "added"} successfully!`
        );

        setIsWhatsAppModalOpen(false);
        resetFormStates();
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error(`Failed to ${isEditMode ? "update" : "submit"} template`);
    } finally {
      setIsLoading(false);
    }
  };

  // Open appropriate modal based on active tab
  const handleAddTemplate = () => {
    resetFormStates();

    if (activeTab === "WhatsApp") {
      setIsWhatsAppModalOpen(true);
    }
  };

  // Render dynamic fields based on template variables
  const renderDynamicFields = () => {
    return dynamicFields.map((field, index) => {
      if (field.type === "image") {
        return (
          <div key={index} className="col-md-12">
            <label className="form-label">
              {field.label} <span className="text-danger">*</span>
            </label>
            <input
              type="file"
              {...whatsappForm.register(field.name, {
                required: `${field.label} is required`,
              })}
              className={`form-control mb-2 `}
              accept="image/*"
            />
            {whatsappForm.formState.errors[field.name] && (
              <div className="text-danger small mt-1">
                {whatsappForm.formState.errors[field.name].message}
              </div>
            )}
          </div>
        );
      } else if (field.type === "url") {
        return (
          <div key={index} className="col-md-12">
            <label className="form-label">
              {field.label} <span className="text-danger">*</span>
            </label>
            <input
              type="url"
              {...whatsappForm.register(field.name, {
                required: `${field.label} is required`,
                validate: (value) => {
                  try {
                    new URL(value);
                    return true;
                  } catch {
                    return "Please enter a valid URL";
                  }
                },
              })}
              className={`form-control mb-2 `}
              placeholder={`Enter ${field.label}`}
            />
            {whatsappForm.formState.errors[field.name] && (
              <div className="text-danger small mt-1">
                {whatsappForm.formState.errors[field.name].message}
              </div>
            )}
          </div>
        );
      } else {
        return (
          <div key={index} className="col-md-12">
            <label className="form-label">
              {field.label} <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              {...whatsappForm.register(field.name, {
                required: `${field.label} is required`,
              })}
              className={`form-control mb-2 `}
              placeholder={`Enter ${field.label}`}
            />
            {whatsappForm.formState.errors[field.name] && (
              <div className="text-danger small mt-1">
                {whatsappForm.formState.errors[field.name].message}
              </div>
            )}
          </div>
        );
      }
    });
  };

  return (
    <div>
      {/* Header Section */}

      <div className="border-bottom pb-2">
        <div className="d-flex align-items-start justify-content-between w-100">
          <div>
            <h5 className=" mb-0">
              {isEditMode ? "Edit" : "Add"} WhatsApp Template
            </h5>
            <small className="text-muted">
              {isEditMode ? "Edit" : "Add a new"} WhatsApp template for
              notifications
            </small>
          </div>
        </div>
      </div>
      <div className=" pt-3">
        {isLoading ? (
          <div className="text-center py-4">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <form onSubmit={whatsappForm.handleSubmit(onSubmit)}>
            <div className="row g-3">
              <div className="col-md-12">
                <label className="form-label">
                  Email Campainging Name <span className="text-danger">*</span>
                </label>

                <input
                  type="text"
                  {...whatsappForm.register("campaingingName")}
                  className={`form-control `}
                  placeholder="Enter template ID"
                />

                {/* <Controller
                          name="templateName"
                          control={whatsappForm.control}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={whatsappTemplateOptions}
                              placeholder="Select Template Name"
                              className={`react-select-container`}
                              classNamePrefix="react-select"
                              value={whatsappTemplateOptions.find(
                                (option) => option.value === field.value
                              )}
                              onChange={(option) =>
                                field.onChange(option?.value)
                              }
                              isClearable={true}
                            />
                          )}
                        /> */}
                {whatsappForm.formState.errors.campaingingName && (
                  <div className="text-danger small mt-1">
                    {whatsappForm.formState.errors.campaingingName.message}
                  </div>
                )}
              </div>

              <div className="col-md-12">
                <label className="form-label">
                  Template ID <span className="text-danger">*</span>
                </label>
                <div className="d-flex gap-2">
                  <Controller
                                    name="templateId"
                                    control={whatsappForm.control}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            className="input-box-select w-100"
                                            options={templateModuleOption}
                                            placeholder="Select a template"
                                            isClearable
                                            isSearchable
                                            onChange={(selected) => field.onChange(selected?.value)}
                                            value={templateModuleOption.find((option) => option.value === field.value) || null}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            }}
                                        />
                                    )}
                                />
                  <Button
                    variant="primary"
                    onClick={onWhatsAPPFetch}
                    disabled={isLoading || !whatsappForm.watch("templateId")}
                  >
                    {isLoading ? "Fetching..." : "Fetch"}
                  </Button>
                </div>
                {whatsappForm.formState.errors.templateId && (
                  <div className="text-danger small mt-1">
                    {whatsappForm.formState.errors.templateId.message}
                  </div>
                )}
              </div>

              <div className="col-md-12">
                <label className="form-label">
                  Template Content <span className="text-danger">*</span>
                </label>
                <textarea
                  {...whatsappForm.register("templateContent")}
                  className={`form-control`}
                  rows={10}
                  placeholder="Enter template content"
                  value={
                    whatsappTemplateData?.content ||
                    whatsappForm.watch("templateContent")
                  }
                  onChange={(e) => {
                    whatsappForm.setValue("templateContent", e.target.value);
                    // Auto-resize logic
                    e.target.style.height = "auto";
                    e.target.style.height = `${e.target.scrollHeight}px`;
                  }}
                  style={{
                    minHeight: "100px",
                    resize: "none",
                    overflow: "none",
                  }}
                  readOnly={true}
                />
                {whatsappForm.formState.errors.templateContent && (
                  <div className="text-danger small mt-1">
                    {whatsappForm.formState.errors.templateContent.message}
                  </div>
                )}
              </div>

              {/* Dynamic Fields Section */}
              {dynamicFields.length > 0 && (
                <div className="col-md-12">
                  <h5 className="mb-3">Template Variables</h5>
                  <div className="row g-3">{renderDynamicFields()}</div>
                </div>
              )}
            </div>
            <div className="d-flex justify-content-end gap-2 mt-4">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => {
                  setIsWhatsAppModalOpen(false);
                  resetFormStates();
                }}
                disabled={isLoading}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn"
                style={{
                  backgroundColor: "rgb(122,58,94)",
                  color: "white",
                }}
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    {isEditMode ? "Updating..." : "Saving..."}
                  </>
                ) : isEditMode ? (
                  "Update"
                ) : (
                  "Save"
                )}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
